import React, { createContext, useState, useContext } from 'react';

export interface ConfirmDialogData {
  title: string;
  content: string | React.ReactElement;
  handleOnOk: () => void;
}

interface ConfirmDialogContextType {
  isOpen: boolean;
  dialogData: ConfirmDialogData | null;
  openConfirmDialog: (data: ConfirmDialogData) => void;
  closeConfirmDialog: () => void;
}

const ConfirmDialogContext = createContext<ConfirmDialogContextType>({
  isOpen: false,
  dialogData: null,
  openConfirmDialog: () => {},
  closeConfirmDialog: () => {},
});

export const ConfirmDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogData, setDialogData] = useState<ConfirmDialogData | null>(null);

  const openConfirmDialog = (data: ConfirmDialogData) => {
    setDialogData(data);
    setIsOpen(true);
  };

  const closeConfirmDialog = () => {
    setIsOpen(false);
    setDialogData(null);
  };

  return (
    <ConfirmDialogContext.Provider value={{ isOpen, dialogData, openConfirmDialog, closeConfirmDialog }}>
      {children}
    </ConfirmDialogContext.Provider>
  );
};

export const useConfirmDialog = () => useContext(ConfirmDialogContext);
